import React,{useState,useEffect,useContext} from 'react';
import { sizing } from '@mui/system';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import {Link,useHistory} from 'react-router-dom';
import {AuthContext} from '../Context/AuthContext';


export default function Header() {
    const history=useHistory();
    const{user,Logout}=useContext(AuthContext);

    function handleLogin()
    {
        history.push("/login");
    }

    function handleLogout()
    {
        Logout();
        history.push("/");
    }

    function handleSignup()
    {
        history.push("/signup");
    }

    function handleProfile()
    {
        history.push("/profile");
    }

    function handleCart()
    {
        history.push("/cart");
    }

    function handleHome()
    {
        history.push("/");
    }

    function handleOrder()
    {
        history.push("/orders");
    }

    

  return (
      <div>
          {
              user===null?
              <div className="card-btns">
        <div className="overlay" />
        <div className="utility-nav d-none d-md-block">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-6">
                <p className="small"><i className="bx bx-envelope" /> klystores@web.com | <i className="bx bx-phone" /> +91-7003532608
                </p>
              </div>
              <div className="col-12 col-md-6 text-right">
                <p className="small">Free shipping on total of ₹5000 and above of all products</p>
              </div>
            </div>
          </div>
        </div>
        <nav className="navbar navbar-expand-md navbar-light bg-light main-menu" style={{boxShadow: 'none'}}>
          <div className="container">
            <button type="button" id="sidebarCollapse" className="btn btn-link d-block d-md-none">
              <i className="bx bx-menu icon-single" />
            </button>
            <div className="navbar-brand crt-btns">
                <button type="button" class="btn btn-primary" onClick={handleCart}>Go to Cart</button>&nbsp;&nbsp;
                <button type="button" class="btn btn-primary" onClick={handleHome}>Go to Home</button>
            </div>
            <ul className="navbar-nav ml-auto d-block d-md-none">
              <li className="nav-item">
                <a className="btn btn-link" href="#"><i className="bx bxs-cart icon-single" /> <span className="badge badge-danger">3</span></a>
              </li>
            </ul>
            <div className="collapse navbar-collapse">
              <form className="form-inline my-2 my-lg-0 mx-auto">
              <h2>KALYANI STORES</h2>
              </form>
              
              <ul className="navbar-nav">
                <li className="nav-item ml-md-3">
                  <a className="btn btn-primary" href="#" onClick={handleLogin}><i className="bx bxs-user-circle mr-1" /> Log In / Register</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
        </div>
              :
              <div className="card-btns">
        <div className="overlay" />
        <div className="utility-nav d-none d-md-block">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-6">
                <p className="small"><i className="bx bx-envelope" /> klystores@web.com | <i className="bx bx-phone" /> +91-7003532608
                </p>
              </div>
              <div className="col-12 col-md-6 text-right">
                <p className="small">Free shipping on total of ₹5000 and above of all products</p>
              </div>
            </div>
          </div>
        </div>
        <nav className="navbar navbar-expand-md navbar-light bg-light main-menu" style={{boxShadow: 'none'}}>
          <div className="container">
            <button type="button" id="sidebarCollapse" className="btn btn-link d-block d-md-none">
              <i className="bx bx-menu icon-single" />
            </button>
            <div className="navbar-brand">
                <button type="button" class="btn btn-primary" onClick={handleCart}>Go to Cart</button>&nbsp;&nbsp;
                <button type="button" class="btn btn-primary" onClick={handleHome}>Go to Home</button>&nbsp;&nbsp;
                <button type="button" class="btn btn-primary" onClick={handleOrder}>My Orders</button>
            </div>
            <ul className="navbar-nav ml-auto d-block d-md-none">
              <li className="nav-item">
                <a className="btn btn-link" href="#"><i className="bx bxs-cart icon-single" /> <span className="badge badge-danger">3</span></a>
              </li>
            </ul>
            <div className="collapse navbar-collapse">
              <form className="form-inline my-2 my-lg-0 mx-auto">
              <h2>KALYANI STORES</h2>
              </form>
              
              <ul className="navbar-nav">
                <li className="nav-item ml-md-3">
                <a className="btn btn-primary" href="#" onClick={handleProfile}><i className="bx bxs-user-circle mr-1" /> My Profile</a> &nbsp;&nbsp;
                  <a className="btn btn-primary" href="#" onClick={handleLogout}><i className="bx bxs-user-circle mr-1" /> Log Out</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
        </div>
        }
      </div>
  )
}
